import Button from "olive-react-myoneui/lib/Button";
import { useNavigate } from "react-router-dom";
import { calendarIcon101, checkCircleIcon, rightArrowLong, stackIcon } from "../../../constants/icons";

function BundleItem({
  className,
  bundleImage,
  bundleType,
  bundleTitle,
  bundleCoursesCount,
  bundleTotalCount,
  bundleStatus,
  bundleButtonLabel,
  bundleStartLink,
  bundleDeadline,
  isExpired,
  bundleTypeLearning,
}) {
  const navigate = useNavigate();
  const startClickHandler = (e) => {
    if (bundleStartLink && !isExpired) {
      navigate(bundleStartLink);
    }
  };

  return (
    <div className={`myk__course-wrapper ${bundleType ? bundleType.toLowerCase() : ''} ${bundleStatus === "inProgress" ? 'resumable-course' : ''}`}>
      <div className={`${className || ""} myk__course-block`}>
        <div className="myk__course-img cursor-pointer" onClick={startClickHandler}>
          <img src={bundleImage} className="img-fluid" />
        </div>
        <div className="myk__course-desc">
          {bundleDeadline && <p>{calendarIcon101} {bundleDeadline}</p>}
          <h1 onClick={startClickHandler}>{bundleTitle}</h1>
          <div className="myk__course-meta-data">
            {bundleCoursesCount && <span>{bundleCoursesCount}</span>}
            {bundleTypeLearning && <span>{bundleTypeLearning}</span>}
          </div>
          {!isExpired && bundleStatus === "completed" && (
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white"
              size="sm"
              onClick={startClickHandler}
            >
             {checkCircleIcon} Completed
            </Button>
          )}
          
          {!isExpired && bundleStatus === "inProgress" && (
            <>
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white btn-resume"
              size="sm"
              onClick={startClickHandler}
            >
              Resume Bundle {rightArrowLong}
            </Button>
            </>
          )}

          {!isExpired && bundleStatus === "notStarted" && (
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white"
              size="sm"
              onClick={startClickHandler}
            >
              {bundleButtonLabel} {rightArrowLong}
            </Button>
          )}
          {isExpired && (
            <Button
              variant="outline"
              className="btn-round bg-transparent text-white border-white"
              size="sm"
              disabled
            >
              Expired
            </Button>
          )}
        </div>
      </div>
      {bundleTotalCount !== undefined && bundleTotalCount !== null && (
        <div className={`d-flex align-items-center justify-content-center gap-1 myk__dashboard-course-tag ${bundleType ? bundleType.toLowerCase() : ''}`}>
          {
            <span>{stackIcon} {bundleTotalCount} in 1</span>
          }
        </div>
      )}
    </div>
  );
}

export default BundleItem;